export const BULK_BATCH_SIZE = 200;

export function chunkArray<T>(items: readonly T[], size: number = BULK_BATCH_SIZE): T[][] {
  if (size <= 0) throw new Error("chunk size must be positive");
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size) as T[]);
  }
  return chunks;
}

export type BulkOperationProgress = {
  completed: number;
  total: number;
  label: string;
};

export function bulkProgressPercent(progress: BulkOperationProgress): number {
  if (progress.total <= 0) return 0;
  return Math.min(100, Math.round((progress.completed / progress.total) * 100));
}
